import { makeStyles, Theme } from '@material-ui/core/styles';
import JETLightPalette from '@src/themes/JETLightPalette.module.scss';
import { JetThemeLight } from '@src/themes/JETTheme';

const useStyles = makeStyles(
  ({ spacing, palette, breakpoints, typography }: Theme) => ({
    scrollPaper: {
      [breakpoints.up('sm')]: {
        maxWidth: '400px',
        margin: '0 0 0 auto',
      },
      [breakpoints.up('lg')]: {
        maxWidth: 'none',
        margin: 0,
      },
    },
    root: {
      backgroundColor: palette.background.default,
      [breakpoints.up('lg')]: {
        width: '780px',
      },
    },
    header: {
      backgroundColor: JETLightPalette.containerDefault,
      height: '56px',
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      position: 'relative',
      paddingLeft: JetThemeLight.variables?.spacingD,
      paddingRight: JetThemeLight.variables?.spacingD,
      justifyContent: 'space-between',
      borderBottom: `1px solid ${JETLightPalette.borderDefault}`,
      marginBottom: JetThemeLight.variables?.spacingC,
    },
    title: {
      ...typography.h4,
      lineHeight: 1.5,
      color: palette.primary.contrastText,
      flex: 1,
      textAlign: 'center',
    },
    content: {
      width: '352px',
      ['@media only screen and (max-width:1028px)']: {
        top: '288px',
        paddingLeft: JetThemeLight.variables?.spacingD,
        paddingRight: JetThemeLight.variables?.spacingD,
      },
    },
    langList: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      flexDirection: 'column',
      [breakpoints.up('lg')]: {
        display: 'flex',
        flexWrap: 'wrap',
      },
    },
    langListItem: {
      marginBottom: JetThemeLight.variables?.spacingE,
      [breakpoints.up('lg')]: {
        width: '50%',
        padding: spacing(0, 1.5),
      },
      '&:last-child': {
        margin: 0,
        [breakpoints.up('lg')]: {
          margin: spacing(0, 0, 1),
        },
      },
      '& button': {
        width: '100%',
        color:
          (palette.jet && palette?.jet?.contentInteractiveDark) ||
          palette.secondary.contrastText,
        backgroundColor: palette.primary.contrastText,
        border: 'none',
        fontFamily: typography.fontFamily,
        fontSize: '1rem',
        lineHeight: 1.5,
        paddingLeft: '0px',
        position: 'relative',
        textAlign: 'left',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        '& .icon-flag': {
          marginRight: JetThemeLight.variables?.spacingD,
        },
        '& .icon-active': {},
      },
    },
    backBtn: {
      position: 'absolute',
      left: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    closeBtn: {
      position: 'absolute',
      right: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  })
);

export default useStyles;
